export const PaymentHistoryStatistic = '/PaymentHistoryStatistic'